var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container",
      class: { "container-data": !_vm.isEmpty(_vm.metric) }
    },
    [
      _c("div", { staticClass: "row" }, [
        _vm.metric.added !== undefined
          ? _c(
              "div",
              {
                staticClass: "card align-self-start",
                class: {
                  "col-12": _vm.isEmpty(_vm.metric.removed),
                  "col-6": !_vm.isEmpty(_vm.metric.removed)
                }
              },
              [
                _c("div", { staticClass: "card-body" }, [
                  _c("h3", { staticClass: "card-title" }, [
                    _vm._v(
                      "Added | " +
                        _vm._s(
                          _vm._f("monent")(
                            _vm.graphProperties.date,
                            "DD-MM-YYYY hh:mm:ss"
                          )
                        )
                    )
                  ]),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.metric.added, function(index, instance) {
                        return _c(
                          "tr",
                          {
                            key:
                              "" + _vm.metric.count + "" + index + Math.random()
                          },
                          [
                            _c("td", [_vm._v(_vm._s(instance))]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.metric.added[instance]))
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          : _c("div"),
        _vm._v(" "),
        !_vm.isEmpty(_vm.metric.removed)
          ? _c("div", { staticClass: "card col-6 align-self-start" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h3", { staticClass: "card-title" }, [
                  _vm._v(
                    "Removed | " +
                      _vm._s(
                        _vm._f("moment")(
                          _vm.graphProperties.date,
                          "DD-MM-YYYY hh:mm:ss"
                        )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("table", { staticClass: "table" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.metric.removed, function(index, instance) {
                      return _c(
                        "tr",
                        {
                          key:
                            "" + _vm.metric.count + "" + index + Math.random()
                        },
                        [
                          _c("td", [_vm._v(_vm._s(instance))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.metric.removed[instance]))
                          ])
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ])
          : _c("div")
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", { attrs: { scope: "col" } }, [_vm._v("Service")]),
      _vm._v(" "),
      _c("th", { attrs: { scope: "col" } }, [_vm._v("Total Added")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("th", { attrs: { scope: "col" } }, [_vm._v("Service")]),
      _vm._v(" "),
      _c("th", { attrs: { scope: "col" } }, [_vm._v("Total Removed")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77e9e124", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e9e124","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deployment/MetricData.vue
// module id = null
// module chunks = 